import DatabaseModel from './DatabaseModel.js';

var AiContextQueryRules = Object.create(DatabaseModel);

AiContextQueryRules.model = 'ai/agent/context/query-rules';
AiContextQueryRules.modelFront = 'ai/agent/context/query-rules';

export default AiContextQueryRules;
